<template>
  <button @click.prevent="destroy">Permanently Delete Account</button>
</template>

<script>
import DeleteAccountModal from './DeleteAccountModal';

export default {
    methods: {
        destroy() {
            Modal.show(DeleteAccountModal).then(response => {
                window.location = '/auth/logout';
            }).catch(err => {console.error(err)});
        }
    }
}
</script>